/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Label, MultipleSelect, SelectButton } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { Fieldset } from "~/components/Forms";
import { PriceType, PriceTypeDisplay } from "~/models";

type PricingTypeProps = {
  setPricingType: React.Dispatch<React.SetStateAction<PriceType>>;
  pricingType: string;
};
function PricingType({ setPricingType, pricingType }: PricingTypeProps) {
  return (
    <Fieldset>
      <Label name="Pricing Type" />
      <FlexContainer>
        <MultipleSelect size="small">
          <SelectButton
            name={PriceType.CAPACITY_BASED_FEE}
            value={PriceType.CAPACITY_BASED_FEE}
            labelText={PriceTypeDisplay.CAPACITY_BASED_FEE}
            onClick={() => {
              setPricingType(PriceType.CAPACITY_BASED_FEE);
            }}
            isActive={pricingType === PriceType.CAPACITY_BASED_FEE}
          />
          <SelectButton
            name={PriceType.INCLUDED_IN_BASE_FEE}
            value={PriceType.INCLUDED_IN_BASE_FEE}
            labelText={PriceTypeDisplay.INCLUDED_IN_BASE_FEE}
            onClick={() => {
              setPricingType(PriceType.INCLUDED_IN_BASE_FEE);
            }}
            isActive={pricingType === PriceType.INCLUDED_IN_BASE_FEE}
          />
          <SelectButton
            name={PriceType.TIME_AND_MATERIAL}
            value={PriceType.TIME_AND_MATERIAL}
            labelText={PriceTypeDisplay.TIME_AND_MATERIAL}
            onClick={() => {
              setPricingType(PriceType.TIME_AND_MATERIAL);
            }}
            isActive={pricingType === PriceType.TIME_AND_MATERIAL}
          />
          <SelectButton
            name={PriceType.CUSTOM}
            value={PriceType.CUSTOM}
            labelText={PriceTypeDisplay.CUSTOM}
            onClick={() => {
              setPricingType(PriceType.CUSTOM);
            }}
            isActive={pricingType === PriceType.CUSTOM}
          />
        </MultipleSelect>
      </FlexContainer>
    </Fieldset>
  );
}

export { PricingType };
